import api from '../services/api';

const VISITOR_ID_KEY = 'flashcv_visitor_id';
const LAST_PING_KEY = 'flashcv_last_visit_ping';

function getOrCreateVisitorId(): string {
    let id = localStorage.getItem(VISITOR_ID_KEY);
    if (!id) {
        id =
            typeof crypto !== 'undefined' && 'randomUUID' in crypto
                ? crypto.randomUUID()
                : `v_${Date.now()}_${Math.random().toString(36).slice(2)}`;
        localStorage.setItem(VISITOR_ID_KEY, id);
    }
    return id;
}

/**
 * Signale une visite au plus une fois par jour et par navigateur.
 * Aucune donnée personnelle envoyée : un identifiant anonyme généré côté client.
 */
export function trackDailyVisit(): void {
    try {
        const today = new Date().toISOString().slice(0, 10);
        if (localStorage.getItem(LAST_PING_KEY) === today) return;
        const visitorId = getOrCreateVisitorId();
        api.post('/visits/ping', { visitorId }).catch(() => {});
        localStorage.setItem(LAST_PING_KEY, today);
    } catch {
        /* localStorage indisponible (navigation privée, etc.) — on ignore */
    }
}
